// Ragi content data.
// All content is editorial and specific. Placeholders are clearly marked.

export const BRAND = {
  name: "Ragi",
  parent: "Ragi", legalName: "Ragi Media",
  city: "Bengaluru",
  country: "India",
  yearsExperience: "16",
  brandsServed: "600+",
  projectsCompleted: "20,000+",
  clientRating: "4.9/5",
  teamSize: "~30",
  phone: "+91 96193 17339",
  phoneHref: "tel:+919619317339",
  whatsapp: "+91 96193 17339",
  whatsappHref: "https://wa.me/919619317339",
  email: "hello@ragi.design",
  emailAlt: "info@ragimedia.com",
  meetingHref: "/book-meeting",
  logo: {
    light: "https://customer-assets-agu9un31.emergentagent.net/job_design-studio-build-5/artifacts/tvd77kfu_Ragi%20new%20logo%20update-02-01.png",
    dark: "https://customer-assets-agu9un31.emergentagent.net/job_design-studio-build-5/artifacts/p4g7k02u_Ragi%20new%20logo%20update-02-02.png",
  },
  socials: {
    instagram: "https://instagram.com/ragimedia",
    linkedin: "https://linkedin.com/company/ragi-media",
    behance: "https://behance.net/ragimedia",
    dribbble: "https://dribbble.com/ragimedia",
  },
};

export const CLIENTS = [
  "Bosch",
  "Biocon",
  "Toyota Tsusho",
  "Swiggy",
  "Adecco",
  "Nykaa",
  "Widex",
  "Cothas Coffee",
  "Emma Sleep",
  "Kalpataru",
  "Royaloak",
  "Nature's Basket",
  "Kuku FM",
  "OPEN",
  "SuperK",
  "Thriveni Earthmovers",
  "Great Learning",
  "CarDekho",
];

export const SERVICE_CATEGORIES = [
  {
    slug: "brand",
    label: "Brand",
    services: [
      { slug: "brand-strategy", name: "Brand Strategy" },
      { slug: "brand-naming", name: "Brand Naming" },
      { slug: "logo-design", name: "Logo Design" },
      { slug: "brand-identity", name: "Brand Identity" },
      { slug: "brand-guidelines", name: "Brand Guidelines" },
      { slug: "brand-refresh", name: "Brand Refresh" },
      { slug: "employer-branding", name: "Employer Branding" },
    ],
  },
  {
    slug: "digital",
    label: "Digital",
    services: [
      { slug: "website-design", name: "Website Design" },
      { slug: "website-development", name: "Website Development" },
      { slug: "ui-design", name: "UI Design" },
      { slug: "ux-design", name: "UX Design" },
      { slug: "mobile-app-design", name: "Mobile App Design" },
      { slug: "product-design", name: "Product Design" },
      { slug: "design-systems", name: "Design Systems" },
    ],
  },
  {
    slug: "packaging",
    label: "Packaging",
    services: [
      { slug: "packaging-design", name: "Packaging Design" },
      { slug: "structural-packaging", name: "Structural Packaging" },
      { slug: "label-design", name: "Label Design" },
    ],
  },
  {
    slug: "communication",
    label: "Communication",
    services: [
      { slug: "corporate-presentation", name: "Corporate Presentation" },
      { slug: "investor-pitch", name: "Investor Pitch Deck" },
      { slug: "brochure-design", name: "Brochure Design" },
      { slug: "catalogue-design", name: "Catalogue Design" },
      { slug: "annual-report", name: "Annual Report" },
      { slug: "infographic-design", name: "Infographic Design" },
      { slug: "visual-communication", name: "Visual Communication" },
    ],
  },
  {
    slug: "motion",
    label: "Motion & Media",
    services: [
      { slug: "social-media-design", name: "Social Media Design" },
      { slug: "campaign-design", name: "Campaign Design" },
      { slug: "advertising-design", name: "Advertising Design" },
      { slug: "illustration", name: "Illustration" },
      { slug: "motion-graphics", name: "Motion Graphics" },
      { slug: "video-design", name: "Video Design" },
      { slug: "3d-design", name: "3D Design" },
    ],
  },
  {
    slug: "consulting",
    label: "Consulting",
    services: [
      { slug: "creative-direction", name: "Creative Direction" },
      { slug: "design-consulting", name: "Design Consulting" },
      { slug: "ai-assisted-creative", name: "AI-Assisted Creative" },
    ],
  },
];

export const CORE_SERVICES_HOME = [
  {
    number: "01",
    title: "Brand",
    slug: "brand-identity",
    body: "Strategy, positioning, naming, identity and brand systems that create clarity and recognition.",
  },
  {
    number: "02",
    title: "Digital",
    slug: "website-design",
    body: "Websites, UI/UX and digital products designed around customers and business goals.",
  },
  {
    number: "03",
    title: "Packaging",
    slug: "packaging-design",
    body: "Packaging and retail communication created to improve visibility, differentiation and product value.",
  },
  {
    number: "04",
    title: "Communication",
    slug: "visual-communication",
    body: "Presentations, brochures, reports and visual communication that make complex messages easier to understand.",
  },
  {
    number: "05",
    title: "Motion & Media",
    slug: "motion-graphics",
    body: "Campaigns, social content, video, motion and visual storytelling built for today's platforms.",
  },
  {
    number: "06",
    title: "Consulting",
    slug: "design-consulting",
    body: "Creative direction and design consulting for businesses that need experienced thinking before execution.",
  },
];

export const INDUSTRIES = [
  { slug: "healthcare", name: "Healthcare", tag: "Hospitals, MedTech, Pharma" },
  { slug: "fmcg", name: "FMCG", tag: "Food, Beverage, Retail" },
  { slug: "technology", name: "Technology", tag: "SaaS, Startups, Platforms" },
  { slug: "finance", name: "Finance", tag: "Fintech, Banking, Wealth" },
  { slug: "real-estate", name: "Real Estate", tag: "Developers, PropTech" },
  { slug: "manufacturing", name: "Manufacturing", tag: "Industrial, B2B" },
  { slug: "education", name: "Education", tag: "EdTech, Institutions" },
  { slug: "hospitality", name: "Hospitality", tag: "Hotels, F&B, Travel" },
  { slug: "jewellery", name: "Jewellery", tag: "Luxury, Heritage" },
  { slug: "automotive", name: "Automotive", tag: "Mobility, EV" },
  { slug: "government", name: "Government", tag: "Public sector, PSU" },
  { slug: "non-profit", name: "Non-Profit", tag: "Social, Cultural" },
];

export const PROJECTS = [
  {
    slug: "drool-over-cheesecakes",
    title: "Drool Over Cheesecakes",
    client: "Drool Over Cheesecakes",
    industry: "Food & Beverage",
    location: "Bengaluru, India",
    services: ["Brand Strategy", "Logo Design", "Visual Identity", "Packaging Design", "Menu Design", "Print Collateral", "Social Media Design", "Brand Communication"],
    tag: "Brand & Packaging",
    year: "2023",
    tagline: "from a homegrown passion to a memorable dessert brand.",
    heroImage: "/images/drool-over/hero.jpg",
    thumb: "/images/drool-over/a.jpg",
    gallery: ["/images/drool-over/a.jpg", "/images/drool-over/d.jpg", "/images/drool-over/c.jpg", "/images/drool-over/b.jpg"],
    challenge:
      "How do you visually translate the experience of eating a premium cheesecake into a brand? From a homegrown passion to a memorable dessert brand.",
    context:
      "The founders began baking from a home kitchen in 2018. By late 2023 the cheesecakes had a following of their own, showing up at birthdays, celebrations and gifting. A good product was no longer enough. The brand needed an identity customers could recognise, remember and emotionally connect with.",
    summary:
      "A complete visual system for a Bengaluru dessert brand: strategy, logo, deep green and cream identity, packaging, menus, print and social communication.",
    result: "4.9 / 5 on Google, 200+ reviews",
    timeline: "December 2023 onwards",
    quote: {
      text: "Branding is not complete when the designer exports the final logo. It starts becoming meaningful when customers begin experiencing it repeatedly.",
      by: "Ragi",
      role: "Creative & Branding Partner",
    },
    story: [
      {
        n: "01",
        label: "The story",
        paragraphs: [
          "Some brands begin with a business plan. Others begin with a passion. Drool Over Cheesecakes belongs to the second kind.",
          "The founders began their baking journey in 2018, working from a home kitchen and developing their craft around one simple idea: creating cheesecakes that people genuinely loved eating. Over time the cheesecakes became part of birthdays, celebrations, gifting, family moments and everyday cravings. The product was developing its own following.",
          "But as the business grew, the brand needed to grow with it. A good product alone was no longer enough. Drool Over Cheesecakes needed an identity customers could recognise, remember and emotionally connect with. That is where Ragi entered the journey.",
        ],
      },
      {
        n: "02",
        label: "The challenge",
        paragraphs: [
          "When we started working with Drool Over Cheesecakes in December 2023, the objective was not simply to design a beautiful logo. The bigger challenge was: how do we visually translate the experience of eating a premium cheesecake into a brand?",
          "The identity had to feel delicious without becoming childish. Premium without becoming inaccessible. Modern without becoming generic. Playful without losing sophistication. And most importantly, it needed enough flexibility to work everywhere, from a small sticker on a cheesecake box to menus, takeaway bags, social media and eventually a physical café environment.",
          "This meant we were not designing an isolated logo. We were designing a complete visual system.",
        ],
        image: "/images/drool-over/a.jpg",
        imageAlt: "Drool Over Cheesecakes brand world with packaging and desserts",
      },
      {
        n: "03",
        label: "Understanding the product",
        paragraphs: [
          "Food branding begins with understanding the food. Cheesecake is fundamentally an indulgence product. People rarely buy cheesecake because they need it. They buy it to celebrate, reward themselves, surprise someone, satisfy a craving or make an ordinary moment feel special.",
          "That distinction shaped our creative direction. Instead of positioning Drool Over Cheesecakes as another bakery, we wanted the identity to communicate an emotional experience: craving, indulgence, celebration, premium taste. The brand had to make someone want the cheesecake before they had tasted it.",
        ],
      },
      {
        n: "04",
        label: "Positioning",
        paragraphs: [
          "We developed the visual direction around a simple idea: make cheesecake feel irresistible. The identity needed to sit comfortably between an artisanal dessert brand and a contemporary premium café.",
          "Four characteristics guided every decision. Premium, because the product deserved a sophisticated presentation. Warm, because desserts are deeply connected with happiness and celebration. Memorable, because customers should recognise the brand quickly. Scalable, because the identity needed to keep working as the business expanded.",
        ],
      },
      {
        n: "05",
        label: "Logo development",
        paragraphs: [
          "Rather than jumping to a finished mark, we explored different ways of representing the personality of Drool Over Cheesecakes: typography, symbols, dessert cues, cheesecake forms, proportions, and how the identity would behave across applications.",
          "The final direction moved toward a cleaner, more sophisticated visual language. Cheesecake-inspired iconography creates an immediate relationship with the category, while the typography gives the identity a recognisable personality of its own. The objective was simplicity with character.",
        ],
        image: "/images/drool-over/c.jpg",
        imageAlt: "Drool Over Cheesecakes storefront signage",
      },
      {
        n: "06",
        label: "The colour story",
        paragraphs: [
          "Instead of the predictable pink, brown or bright bakery palette, we built a more distinctive visual environment.",
          "Deep green gives the brand confidence, sophistication and depth, and sets it apart from conventional dessert branding. Cream and dessert-inspired neutrals connect the identity with cheesecake, dairy, softness and indulgence, and give the green room to breathe. Refined gold accents were introduced carefully, as an accent rather than decoration, adding a subtle premium quality.",
          "Together, the palette establishes a visual world that feels contemporary today and stays relevant as the brand grows.",
        ],
      },
      {
        n: "07",
        label: "Packaging",
        paragraphs: [
          "For a delivery-driven dessert business, packaging is the storefront that arrives at the customer's home. A customer may never meet the baker or visit the café. Their first physical interaction with the brand could be receiving a cheesecake box.",
          "We developed a packaging language that extends the identity beyond the logo, so customers recognise the brand before reading its name. Colours, graphic elements, typography and spacing work together across cheesecake boxes, takeaway packaging, stickers and labels, carrier bags, menus, flyers and other touchpoints. Every piece belongs to the same family.",
          "Food packaging has two jobs. The first is functional: protect the product. The second is emotional: create anticipation. Customers photograph the box, carry the bag, share celebrations on Instagram and give the product as a gift. Good packaging becomes advertising customers willingly carry. Our approach was to make it distinctive enough to be remembered, and controlled enough that the cheesecake remains the hero.",
        ],
        image: "/images/drool-over/d.jpg",
        imageAlt: "Drool Over Cheesecakes carry box packaging",
      },
      {
        n: "08",
        label: "One brand ecosystem",
        paragraphs: [
          "A brand becomes powerful when customers repeatedly encounter the same personality across touchpoints. So the project expanded beyond logo and packaging into menu design, print communication, the takeaway experience and a digital visual system for social media that communicates products, offers, occasions and personality consistently.",
          "Communication also needed a voice. Instead of treating social media as a catalogue of cheesecake photographs, we built ideas around emotions and situations: Win Hearts with Cheesecake. Blushing with Flavor. Life's Sweet Decisions. Love, birthdays, friendships, celebrations, cravings, gifting, weekend indulgence. Once a food brand becomes connected with occasions, its communication becomes far stronger than product advertising.",
        ],
        image: "/images/drool-over/b.jpg",
        imageAlt: "Love at First Bite campaign poster",
      },
      {
        n: "09",
        label: "The brand today",
        paragraphs: [
          "Drool Over Cheesecakes has grown into a highly rated Bengaluru dessert destination. Its Google listing shows a 4.9 out of 5 rating from more than 200 customer reviews, with customers frequently mentioning flavours, presentation and experience. Popular favourites include blueberry, coconut, mango, Biscoff and chocolate cheesecakes.",
          "What began as a home-based baking passion is now a recognisable, customer-facing dessert business. Seeing the identity functioning in the real market is the most meaningful outcome of the project.",
        ],
      },
      {
        n: "10",
        label: "What we learned",
        paragraphs: [
          "Great branding takes time. Strong identities evolve through exploration, feedback and refinement, not one quick decision.",
          "Packaging builds brand memory. When it is distinctive and consistent, every delivery becomes another moment of recognition.",
          "Food branding must create emotion. Customers can see a cheesecake. Great branding helps them imagine how it will feel to eat it.",
          "Consistency creates recognition, and branding must be designed for growth. Today's homegrown business could become tomorrow's multi-location brand, so the system has to work beyond the immediate requirement.",
        ],
      },
    ],
    credits: [
      ["Brand Strategy & Creative Direction", "Ragi"],
      ["Logo & Visual Identity", "Ragi"],
      ["Packaging Design", "Ragi"],
      ["Brand Communication", "Ragi"],
    ],
  },
  {
    slug: "kavira-tea",
    title: "Kavira Tea",
    client: "Kavira Estates",
    industry: "FMCG",
    location: "Coonoor, India",
    services: ["Brand Identity", "Packaging", "Website"],
    tag: "Packaging & Brand",
    year: "2024",
    heroImage:
      "https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A third-generation estate ready to move from bulk supply into a premium single-origin brand, without losing the seriousness of a working plantation.",
    context:
      "The team had earned trust from wholesale buyers for a decade. The new brand had to speak to independent tea rooms and considered retail, while protecting the estate's craft narrative.",
    summary:
      "A quiet, editorial identity system paired with structured packaging that reads clearly at shelf and closer up.",
    result: "[Add verified retail listing count]",
  },
  {
    slug: "meridian-cardiology",
    title: "Meridian Cardiology",
    client: "Meridian Health Group",
    industry: "Healthcare",
    location: "Bengaluru, India",
    services: ["Brand Identity", "Website", "Wayfinding"],
    tag: "Healthcare Brand",
    year: "2024",
    heroImage:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A specialist cardiology practice unifying six clinics under one calm, credible identity, for patients making difficult decisions.",
    context:
      "Patients arrive anxious. Referring doctors need clarity. The brand had to reassure both audiences without leaning on stock hospital tropes.",
    summary:
      "A modest wordmark, editorial typography and a photography system that respects patients over marketing gloss.",
    result: "[Add verified appointment growth metric]",
  },
  {
    slug: "north-star-capital",
    title: "North Star Capital",
    client: "North Star Partners",
    industry: "Finance",
    location: "Singapore",
    services: ["Brand Identity", "Investor Deck", "Website"],
    tag: "Financial Brand",
    year: "2024",
    heroImage:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A boutique investment firm launching a new India-focused fund needed a brand that could sit across LP conversations, quarterly letters and public web.",
    context:
      "LPs weigh clarity and discipline more than aesthetics. The brand had to feel considered without becoming decorative.",
    summary:
      "A restrained wordmark, a serif-driven document system and a website built for signalling, not persuasion.",
    result: "[Add verified fund close data]",
  },
  {
    slug: "helio-ev",
    title: "Helio EV",
    client: "Helio Mobility",
    industry: "Automotive",
    location: "Pune, India",
    services: ["Brand Identity", "Product UI", "Launch Campaign"],
    tag: "EV Brand & Product",
    year: "2023",
    heroImage:
      "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A performance electric two-wheeler for commuters who care about specifics (range, torque, service), not future-of-mobility slogans.",
    context:
      "Category was crowded with lifestyle brands. Helio needed to feel engineered, adult and slightly severe.",
    summary:
      "A tightly kerned wordmark, a technical photography direction and a companion app UI built for daily use.",
    result: "[Add verified pre-order volume]",
  },
  {
    slug: "kalari-jewellery",
    title: "Kalari",
    client: "Kalari Fine Jewellery",
    industry: "Jewellery",
    location: "Kochi, India",
    services: ["Brand Identity", "Retail Design", "E-commerce"],
    tag: "Jewellery House",
    year: "2023",
    heroImage:
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A heritage jewellery house entering direct-to-consumer without the visual clichés of the category.",
    context:
      "The founding family had a hundred-year archive and a modern buyer. The brand had to honour both without becoming a museum.",
    summary:
      "A serif wordmark, editorial catalogue system and an e-commerce experience that treats each piece as an object.",
    result: "[Add verified DTC revenue metric]",
  },
  {
    slug: "grove-realty",
    title: "Grove",
    client: "Grove Developments",
    industry: "Real Estate",
    location: "Bengaluru, India",
    services: ["Brand Identity", "Website", "Sales Collateral"],
    tag: "Real Estate",
    year: "2023",
    heroImage:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=80",
    thumb:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
    challenge:
      "A residential developer launching a considered mid-rise project. Buyers here are second-time owners, not first-time investors.",
    context:
      "Category defaults to aspirational renders. Grove needed to feel honest, architectural and slower.",
    summary:
      "A wordmark, an architectural photography direction and a sales collateral system built for site visits, not scrolling.",
    result: "[Add verified sales conversion metric]",
  },
];

export const CASE_STUDIES = [
  {
    slug: "drool-over-cheesecakes-brand",
    title: "From a homegrown cheesecake passion to a memorable dessert brand.",
    projectSlug: "drool-over-cheesecakes",
    client: "Drool Over Cheesecakes",
    industry: "Food & Beverage",
    thumb: "/images/drool-over/d.jpg",
    excerpt:
      "A complete visual system for a Bengaluru dessert brand, built to make cheesecake feel irresistible.",
    sections: PROJECTS[0].story,
  },
  {
    slug: "kavira-brand-launch",
    title: "How Kavira moved from bulk supply to a considered retail brand.",
    projectSlug: "kavira-tea",
    client: "Kavira Estates",
    industry: "FMCG",
    thumb: PROJECTS[1].thumb,
    excerpt:
      "A single-origin tea brand reorganised around clarity, not craft clichés.",
  },
  {
    slug: "meridian-patient-first",
    title: "Building a cardiology brand around the patient, not the hospital.",
    projectSlug: "meridian-cardiology",
    client: "Meridian Health Group",
    industry: "Healthcare",
    thumb: PROJECTS[2].thumb,
    excerpt:
      "A calm identity system for a specialist practice serving anxious patients and referring doctors.",
  },
  {
    slug: "north-star-fund-launch",
    title: "A restrained brand for a fund that lets its numbers speak.",
    projectSlug: "north-star-capital",
    client: "North Star Partners",
    industry: "Finance",
    thumb: PROJECTS[3].thumb,
    excerpt:
      "How a boutique investment firm signalled discipline without decoration.",
  },
  {
    slug: "helio-engineering-brand",
    title: "Positioning an electric two-wheeler for buyers who read specs.",
    projectSlug: "helio-ev",
    client: "Helio Mobility",
    industry: "Automotive",
    thumb: PROJECTS[4].thumb,
    excerpt:
      "A technical brand system for a category crowded with lifestyle slogans.",
  },
  {
    slug: "kalari-heritage-dtc",
    title: "Taking a hundred-year jewellery house directly to a modern buyer.",
    projectSlug: "kalari-jewellery",
    client: "Kalari Fine Jewellery",
    industry: "Jewellery",
    thumb: PROJECTS[5].thumb,
    excerpt:
      "An identity and e-commerce system that treats each piece as an object.",
  },
  {
    slug: "grove-architectural-brand",
    title: "A residential brand built for second-time buyers.",
    projectSlug: "grove-realty",
    client: "Grove Developments",
    industry: "Real Estate",
    thumb: PROJECTS[6].thumb,
    excerpt:
      "How Grove replaced aspirational renders with an architectural point of view.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I highly recommend Ragi for any design need. Skilled, responsive, and genuinely invested in the work. Their team provided invaluable insights during our project and delivered beyond our expectations.",
    author: "Manjunath R",
    role: "Client",
    company: "Ragi",
  },
  {
    quote:
      "Working with Ragi has been a game-changer for our brand. The team understood our vision perfectly and turned it into engaging design that boosted our reach and sales. Professional, creative and always on time.",
    author: "Aishwarya",
    role: "Client",
    company: "Ragi",
  },
  {
    quote:
      "Super ideas, beautiful and stunning work generated here. Thanks to Abhijit, the founder, for his suggestions and support in my brand building.",
    author: "Omnath C P",
    role: "Client",
    company: "Ragi",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Discover", body: "Understand the business, customer, market and challenge." },
  { n: "02", title: "Define", body: "Identify the strategy, positioning and creative direction." },
  { n: "03", title: "Create", body: "Build the identity, digital experience, packaging or communication system." },
  { n: "04", title: "Deliver & Grow", body: "Launch the work and support the brand as it moves forward." },
];

export const INSIGHTS = [
  {
    slug: "brand-strategy-is-a-decision-system",
    title: "Brand strategy is a decision system, not a document.",
    date: "2025-01-12",
    readMinutes: 6,
    category: "Brand Strategy",
    excerpt:
      "The best strategies are short, sharp and used weekly. Here is how we write them, and what usually goes wrong.",
  },
  {
    slug: "packaging-that-earns-shelf-space",
    title: "Packaging that earns shelf space: a short field guide.",
    date: "2025-01-05",
    readMinutes: 8,
    category: "Packaging",
    excerpt:
      "Six practical constraints we apply on every packaging project, from category audits to hand tests at the shelf.",
  },
  {
    slug: "healthcare-brands-and-the-patient-experience",
    title: "Healthcare brands and the patient experience.",
    date: "2024-12-18",
    readMinutes: 7,
    category: "Industry Branding",
    excerpt:
      "Why the best hospital and medtech brands quietly outperform louder ones, and how to design for anxious audiences.",
  },
  {
    slug: "when-to-refresh-not-rebrand",
    title: "When to refresh, not rebrand.",
    date: "2024-12-04",
    readMinutes: 5,
    category: "Brand Refresh",
    excerpt:
      "Rebrands are expensive, disruptive and often unnecessary. A shorter list of situations where a refresh is enough.",
  },
];

export const TEAM = [
  { name: "Abhijit J K", role: "Founder & Creative Director" },
  { name: "[Team Member]", role: "Design Lead · Brand" },
  { name: "[Team Member]", role: "Design Lead · Digital" },
  { name: "[Team Member]", role: "Design Lead · Packaging" },
  { name: "[Team Member]", role: "Motion & 3D" },
  { name: "[Team Member]", role: "Strategy & Copy" },
];

export const FOUNDER = {
  name: "Abhijit J K",
  role: "Founder, RAGI",
  headline: "Built by a designer who understands business.",
  intro:
    "Abhijit J K is the Founder of RAGI and a Brand, Design and Business Growth Consultant with 15+ years of experience across branding, visual communication, UI/UX, digital strategy and business-focused creative work. His approach is simple: design should not exist separately from business. It should improve clarity, trust, customer experience and growth.",
  timeline: [
    { year: "2008", label: "Editorial design at The Printers Mysore." },
    { year: "2012", label: "The New Indian Express, consumer media." },
    { year: "2015", label: "Design leadership at Swiggy." },
    { year: "2017", label: "Founded Ragi Media in Bengaluru." },
    { year: "Today", label: "Building RAGI into a global design and growth partner." },
  ],
  philosophy: [
    "Design is a business function.",
    "The best identities are quiet. They compound.",
    "Systems beat one-off decisions.",
    "Senior people stay on the work.",
  ],
  portrait: "/images/abhijit-jk.webp",
};

export const FAQS_HOME = [
  {
    q: "Where is Ragi based, and do you work globally?",
    a: "Our studio is in Bengaluru, India. We work with clients across India, the Middle East, Southeast Asia, Europe and North America.",
  },
  {
    q: "How does Ragi engage with clients?",
    a: "Most engagements start with a short, paid strategy phase. From there, we scope brand, digital, packaging or communication work as separate stages, with clear deliverables and senior involvement throughout.",
  },
  {
    q: "How senior is the team on our project?",
    a: "Every engagement has senior design leadership on it, not only in the pitch. The founder is directly involved in strategy and creative direction on every project we take on.",
  },
  {
    q: "What size of businesses do you work with?",
    a: "Ambitious startups, MSMEs, established enterprises and select government and non-profit organisations. We choose engagements where design can materially affect the business.",
  },
];

export const LOCATIONS = [
  "Bengaluru",
  "Mumbai",
  "Delhi",
  "Hyderabad",
  "Chennai",
  "Pune",
  "Ahmedabad",
  "Kochi",
  "Mysuru",
  "Mangaluru",
  "Dubai",
  "Singapore",
  "London",
  "New York",
];

// Service-specific copy so each service page reads uniquely (not repeated Brand Strategy text).
export const SERVICE_COPY = {
  "brand-strategy": { title: "Brand strategy that gives", tail: "the business direction.", intro: "We help businesses define what they stand for, who they serve, how they should position themselves and how they should communicate. The goal is clarity—not another strategy document nobody uses." },
  "brand-naming": { title: "Names built to be", tail: "remembered.", intro: "We create brand names that are distinctive, relevant, scalable and aligned with the business you're building." },
  "logo-design": { title: "A logo is the start", tail: "of recognition.", intro: "We create distinctive logo systems that help businesses look professional, recognisable and consistent across every customer touchpoint." },
  "brand-identity": { title: "Build a brand people can", tail: "recognise and remember.", intro: "We create complete visual identity systems covering logo, colour, typography, imagery and brand applications." },
  "brand-guidelines": { title: "Keep the brand consistent", tail: "as it grows.", intro: "We create practical brand guidelines that help internal teams, agencies and partners use the identity correctly across every platform." },
  "brand-refresh": { title: "Evolve the brand without", tail: "losing what works.", intro: "We help established businesses modernise their visual identity and communication while protecting existing recognition and brand equity." },
  "employer-branding": { title: "Build a brand people", tail: "want to work for.", intro: "We help organisations create stronger employer communication across recruitment, culture, internal communication and talent branding." },
  "website-design": { title: "Websites designed around", tail: "business goals.", intro: "RAGI creates modern, responsive and conversion-focused websites that communicate clearly, build trust and help customers take action.",
    problems: ["Unclear website communication.", "An outdated visual experience.", "A poor customer journey and weak mobile experience.", "Low credibility and weak conversion paths."],
    deliverables: ["A clear site structure, messaging and page hierarchy.", "Responsive, conversion-focused UI design across devices.", "Reusable components and templates your team can extend.", "Design handoff and support for development and launch."] },
  "website-development": { title: "Reliable digital experiences", tail: "built to perform.", intro: "We turn approved digital designs into responsive, scalable and functional websites built for real users and real business requirements." },
  "ui-design": { title: "Interfaces people", tail: "understand instantly.", intro: "We design clear, intuitive and visually consistent interfaces for websites, applications, dashboards and digital products.",
    deliverables: ["High-fidelity interface design for key screens and states.", "A consistent UI component library and design tokens.", "Interaction and responsive behaviour specifications.", "Developer-ready handoff and design QA support."] },
  "ux-design": { title: "Make every interaction", tail: "easier.", intro: "We improve customer journeys, information architecture, flows and usability so users can understand products and complete important actions with less friction." },
  "mobile-app-design": { title: "Mobile experiences", tail: "built around users.", intro: "We design intuitive mobile applications that balance usability, brand experience and business objectives." },
  "product-design": { title: "From product idea to", tail: "usable experience.", intro: "We help businesses translate product requirements into clear, useful and scalable digital experiences." },
  "design-systems": { title: "Design consistency", tail: "at scale.", intro: "We create reusable design systems that help product and marketing teams work faster while maintaining visual and functional consistency." },
  "packaging-design": { title: "Packaging that gets noticed", tail: "and gets understood.", intro: "RAGI creates packaging that combines brand identity, customer behaviour, product communication and shelf impact.",
    problems: ["Poor shelf visibility and weak product hierarchy.", "An inconsistent product range.", "Low perceived value and confusing information.", "Difficulty extending into new SKUs."],
    deliverables: ["Packaging visual system and structure direction.", "Front, back and side-of-pack information hierarchy.", "A scalable system for variants and new SKUs.", "Print-ready artwork and dielines for production."] },
  "structural-packaging": { title: "Better packaging starts", tail: "with better structure.", intro: "We help develop packaging structures that balance product protection, usability, presentation and brand experience." },
  "label-design": { title: "Labels that", tail: "communicate quickly.", intro: "We create clear and distinctive label systems that help products communicate information, stand out and stay consistent across variants." },
  "corporate-presentation": { title: "Present the business with", tail: "clarity and confidence.", intro: "We design professional presentations that help organisations communicate ideas, capabilities and information clearly." },
  "investor-pitch-deck": { title: "Turn the business story into", tail: "a clear investment story.", intro: "We help founders organise and design pitch decks that communicate the opportunity, business model, traction and vision clearly." },
  "brochure-design": { title: "Business communication", tail: "people want to read.", intro: "We transform products, services and company information into clear, structured and visually strong brochures." },
  "catalogue-design": { title: "Make large product ranges", tail: "easy to understand.", intro: "We create structured catalogues that improve product navigation, presentation and sales communication." },
  "annual-report": { title: "Complex information,", tail: "clearly communicated.", intro: "We design annual reports that combine data, storytelling and brand communication into a professional and easy-to-follow document." },
  "infographic-design": { title: "Turn complex information", tail: "into clear visual stories.", intro: "We simplify data, processes and information using clear visual hierarchy and storytelling." },
  "visual-communication": { title: "Make every business", tail: "message clearer.", intro: "We create visual communication systems that help businesses present information consistently across print, digital and corporate channels." },
  "social-media-design": { title: "Build recognition", tail: "every time you post.", intro: "We create consistent and engaging social media creative systems that help brands stay recognisable and relevant across digital platforms." },
  "campaign-design": { title: "One idea, consistent", tail: "across every touchpoint.", intro: "We develop campaign visual systems that can work across social media, digital advertising, print, outdoor and other communication channels." },
  "advertising-design": { title: "Creative built to capture", tail: "attention and communicate fast.", intro: "We design advertising creatives that combine clear messaging, brand consistency and strong visual impact." },
  "illustration": { title: "Original visual", tail: "storytelling for brands.", intro: "We create custom illustration systems for campaigns, products, packaging, editorial communication and digital experiences." },
  "motion-graphics": { title: "Bring the brand", tail: "into motion.", intro: "We create motion graphics that make brand stories, products and information more engaging across digital channels." },
  "video-design": { title: "Video content designed", tail: "around the message.", intro: "We create and edit brand, product, social and campaign videos with a clear communication objective." },
  "3d-design": { title: "Visualise products, spaces", tail: "and ideas before they exist.", intro: "We create 3D visuals for product communication, packaging, campaigns and branded experiences." },
  "creative-direction": { title: "Senior creative thinking", tail: "across every touchpoint.", intro: "We help businesses establish and maintain a clear creative direction across brand, digital, marketing and communication." },
  "design-consulting": { title: "Experienced design thinking", tail: "for business decisions.", intro: "We work with founders and teams to identify communication problems, improve brand consistency and decide where design can create the greatest business impact." },
  "ai-assisted-creative": { title: "AI speed.", tail: "Human creative direction.", intro: "We use AI where it adds speed, exploration and production efficiency—while strategy, judgement, brand thinking and final creative direction remain human-led." },
};
